export default "/assets/images/graph-pollen-sm.c9c7195e7c8ee8db.png";